import React from 'react';
import Helmet from 'react-helmet';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import ArticleResource from '../components/resources/ArticleResource';
import VideoResource from '../components/resources/VideoResource';
import CaseStudyResource from '../components/resources/CaseStudyResource';

export default ({ data, location }) => {
  const page = data.mdx;
  const frontmatter = page.frontmatter || {};
  const title = frontmatter.title || 'Resource';
  const type = frontmatter.type || 'article';

  return (
    <React.Fragment>
      <Helmet>
        <title>{title} | Ambassador</title>
        <meta name="og:title" content={`${title} | Ambassador`} />
        <meta name="og:type" content="article" />
      </Helmet>
      <Layout location={location}>
        {
          {
            video: (
              <VideoResource
                title={title}
                youtube_embed={frontmatter.youtube_embed}
                description={page.body}
              />
            ),
            case_study: (
              <CaseStudyResource
                content={page.body}
                logo={frontmatter.logo}
                industry={frontmatter.industry}
                size={frontmatter.size}
                quote={frontmatter.quote}
                subtitle={frontmatter.subtitle}
              />
            ),
            post: (
              <ArticleResource
                title={title}
                subtitle={frontmatter.subtitle}
                content={page.body}
              />
            ),
          }[type]
        }
      </Layout>
    </React.Fragment>
  );
};

export const query = graphql`
  query($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      fields {
        slug
      }
      frontmatter {
        type
        title
        subtitle
        logo
        industry
        size
        quote
        subtitle
      }
      headings(depth: h1) {
        value
      }
    }
  }
`;
